function AccountsName() {
    return (
        <p className="contacts__name">
            <strong></strong><br />
        </p>
    );
}

export default AccountsName;
